__turbopack_context__.v({
  "loader-strip": "loader-strip-module-scss-module__MUA9UW__loader-strip",
  "loader-strip-container": "loader-strip-module-scss-module__MUA9UW__loader-strip-container",
});
